import type { ProdantixClient } from 'ProdantixSdk/core/client';
import type { EventProperties } from 'ProdantixSdk/core/types';
import type { FormsHost } from 'ProdantixSdk/web/forms/render';

export type { PopupRules, PopupTrigger } from 'ProdantixSdk/web/forms/popup';
export { isDue, parseTrigger, watchPopup } from 'ProdantixSdk/web/forms/popup';
export type { FormsHost, RenderedForm, RenderFormOptions } from 'ProdantixSdk/web/forms/render';
export { isShown, renderForm } from 'ProdantixSdk/web/forms/render';
export type { FormLanguage } from 'ProdantixSdk/web/forms/strings';
export { formLanguage } from 'ProdantixSdk/web/forms/strings';

/** The renderer's view of a client: its forms, its submissions and its
 *  events, under the visitor the client holds. */
export const formsHost = (client: ProdantixClient): FormsHost => ({
  capture: (event, properties) => client.capture(event, { properties: properties as EventProperties }),
  form: formId => client.getForm(formId),
  submit: (formId, answers, challenge, solution) => client.submitForm(formId, answers, challenge, solution),
});
